import Button from '@material-ui/core/Button'
import Paper from '@material-ui/core/Paper'
import TextField from '@material-ui/core/TextField'
import { withStyles } from '@material-ui/core/styles'
import Link from 'gatsby-link'
import PropTypes from 'prop-types'
import React from 'react'
import logo from '../components/images/logo-autoclub.png'
import Helmet from 'react-helmet'
import favicon from '../components/images/favicon.png'

const styles = theme => ({
  container: {
    width: '70%',
    [theme.breakpoints.down('lg')]: {
      width: '75%',
    },
    [theme.breakpoints.down('md')]: {
      width: '88%',
    },
    [theme.breakpoints.down('sm')]: {
      width: '95%',
    },
    margin: '0 auto',
    padding: '40px 0',
  },
  coloredBandana: {
    backgroundColor: theme.palette.primary.main,
    height: 20,
  },
  colorDark: {
    color: theme.palette.primary.main,
  },
  textFieldShort: {
    width: '47%',
  },
  submitButton: {
    color: theme.palette.primary.second,
    marginTop: 20,
    border: '1px solid',
    borderColor: theme.palette.primary.second,
  },
})

class RequestAReview extends React.Component {
  render() {
    const { classes } = this.props

    return (
      <div className={classes.container}>
        <Helmet>
          <title>Request a review</title>
          <link rel="icon" type="favicon" href={favicon} sizes="16x16" />
        </Helmet>
        <div className={classes.coloredBandana} />
        <Paper style={{ padding: 30 }}>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
            }}
          >
            <Link to={'/'}>
              <img src={logo} width={64} height={37} />
            </Link>
            <h3 className={classes.colorDark} style={{ marginLeft: 20 }}>
              AUTO CLUB REVIEWS - REQUEST A REVIEW
            </h3>
          </div>
          <p className={classes.colorDark}>
            Would you like to find out how good a certain product is?
            <br />
            Thinking of buying a new accessory for your car?
            <br />
            <br /> You can ask us for a review in the form below.
          </p>
        </Paper>
        <div className={classes.coloredBandana} style={{ marginTop: 35 }} />
        <Paper style={{ padding: 30 }}>
          <form
            noValidate
            autoComplete="off"
            method="post"
            data-netlify="true"
            data-netlify-honeypot="bot-field"
            name="request-a-review"
          >
            <input type="hidden" name="form-name" value="request-a-review" />
            <div
              style={{
                width: '100%',
                display: 'flex',
                justifyContent: 'space-between',
              }}
            >
              <TextField
                className={classes.textFieldShort}
                name="name"
                id="name"
                label="Name"
                placeholder="e.g. John Doe"
                margin="normal"
              />
              <TextField
                className={classes.textFieldShort}
                name="email"
                id="email"
                label="Email"
                placeholder="e.g. JohnDoe@gmail.com"
                margin="normal"
              />
            </div>
            <TextField
              fullWidth
              name="productName"
              id="product"
              label="Product Name"
              placeholder="e.g. Fuel injector cleaner"
              margin="normal"
              v
            />
            <TextField
              className={classes.textFieldLong}
              fullWidth
              name="productLink"
              id="link"
              label="Product Link"
              placeholder="e.g. www.amazon.com/product"
              margin="normal"
            />
            <TextField
              fullWidth
              multiline
              name="message"
              id="message"
              label="Message"
              rows="10"
              margin="normal"
            />
            <Button type="submit" className={classes.submitButton}>
              Submit
            </Button>
          </form>
        </Paper>
      </div>
    )
  }
}

RequestAReview.propTypes = {
  classes: PropTypes.object.isRequired,
}

export default withStyles(styles)(RequestAReview)



// WEBPACK FOOTER //
// ./src/pages/request-a-review.js